import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import moment from 'moment'
import momentDe from 'moment/locale/de'
import momentEn from 'moment/locale/en-gb'
import momentFr from 'moment/locale/fr'
import momentNl from 'moment/locale/nl'
import momentNlBe from 'moment/locale/nl-be'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      'nl_NL': ['nl'],
      'default': ['en'],
    },
    ns: ['messages', 'validators', 'security'],
    defaultNS: 'messages',
    nsSeparator: ';;',
    keySeparator: false,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

const locale =
  typeof CONFIGURATION !== 'undefined' ? CONFIGURATION.locale : 'nl'

// Todo think about a standard (iso) way of supporting translation's, this won't scale...
let shortLocale = locale ? locale.substring(0, 2) : 'nl'
if (locale && locale === 'nl_NL') {
  shortLocale = 'nl_NL'
}

i18n.changeLanguage(shortLocale)
const momentLocaleMap = {
  nl_NL: momentNl,
  nl: momentNlBe,
  fr: momentFr,
  de: momentDe,
  en: momentEn,
}
if (momentLocaleMap[shortLocale]) {
  moment.locale(shortLocale)
}

export default i18n
